import { Col, InputNumber, Row } from 'antd'
import styles from './SmsOptions.module.scss'

import type { PunctualityItem, PunctualityType } from 'features/Home/interfaces/IInfoSchedule'
import { Select } from 'common/components/Select/Select'
import { SELECT_CONSTANTS } from 'common/constants/selectConstants'
import type { PatientBufferTime } from 'features/Schedule/api/schedule.types'

type Props = {
  punctuality: PunctualityType[]
  patientPunctuality: PunctualityItem | null
  appointmentPunctualityType: string | number
  appointmentPunctualityMinutes: number
  patientBufferTime: PatientBufferTime
  error: string | undefined
  touched: boolean
  onChangePunctualityType: (value: string) => void
  onChangePunctualityValue: (value: number) => void
}

const getPunctualityType = (punctuality: PunctualityType[], code: number) => {
  return punctuality.find((item) => item.code === code)?.name
}

export const SmsOptions = ({
  appointmentPunctualityType,
  appointmentPunctualityMinutes,
  patientPunctuality,
  punctuality,
  patientBufferTime,
  error,
  touched,
  onChangePunctualityType: onChangePatientPunctualityType,
  onChangePunctualityValue: onChangeAppointmentPunctualityValue,
}: Props) => {
  if (!patientPunctuality || appointmentPunctualityType === undefined || !punctuality.length)
    return null

  // non editable
  const { minutes: patientPunctualityValue } = patientPunctuality
  const patientPunctualityType = getPunctualityType(punctuality, patientPunctuality.code)

  // editable
  const appointmentType = String(appointmentPunctualityType)

  const getMaxValue = () => {
    switch (appointmentType) {
      case '1':
        return patientBufferTime.after
      case '2':
        return patientBufferTime.before
      default:
        return 0
    }
  }

  const isEditable = appointmentType !== '0'

  return (
    <>
      <div className={styles.container}>
        <Row className={styles.labelRow} gutter={[4, 4]} align='middle'>
          <Col>
            <span>Account settings:</span>
          </Col>
          <Col>
            <span>tell patient to arrive</span>
            <span className={styles.value}>{patientPunctualityValue}</span>
            <span>minutes</span>
          </Col>
          <Col>
            <span className={styles.type}>{patientPunctualityType}</span>
          </Col>
          <Col>
            <span>appt time</span>
          </Col>
        </Row>
        <Row className={styles.labelRow} gutter={[4, 4]} align='middle'>
          <Col>
            <span>Appointment settings:</span>
          </Col>
          <Col>
            <span>tell patient to arrive</span>
            <InputNumber
              disabled={!isEditable}
              className={styles.input}
              name='appointment-punctuality'
              placeholder='0'
              min={isEditable ? 1 : 0}
              max={getMaxValue()}
              controls={false}
              onChange={(value) => {
                onChangeAppointmentPunctualityValue(value)
              }}
              value={appointmentPunctualityMinutes}
            />
            <span>minutes</span>
          </Col>
          <Col>
            <Select
              value={appointmentType}
              onSelect={(value) => {
                onChangePatientPunctualityType(value)
                if (value === '0') onChangeAppointmentPunctualityValue(0)
                if (appointmentType === '0') onChangeAppointmentPunctualityValue(1)
              }}
              className={styles.select}
              proportion={SELECT_CONSTANTS.SMALL}
              listOptions={punctuality.map((item) => ({
                code: String(item.code),
                name: item.name,
              }))}
            />
          </Col>
          <Col>
            <span>appt time</span>
          </Col>
        </Row>
      </div>
      {error && touched && <p className='errorMessage'>{String(error)}</p>}
    </>
  )
}
